import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=45e178bc&"
import script from "./AuthLayout.vue?vue&type=script&lang=js&"
export * from "./AuthLayout.vue?vue&type=script&lang=js&"
import style0 from "./AuthLayout.vue?vue&type=style&index=0&id=45e178bc&prod&lang=scss&"
import style1 from "./AuthLayout.vue?vue&type=style&index=1&id=45e178bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports